const TqModifiedByCell = ({ tq }) => {
  const { modified_by } = tq;
  if (!modified_by) return null;

  const displayName = `${modified_by.first_name} ${modified_by.last_name}`;
  return <>{displayName}</>;
};
export default TqModifiedByCell;
